export const getPrettyDateString = (dateString: string): string => {
  const firstArray = dateString.split("T");
  const timeString = firstArray[1];
  const secondArray = timeString.split("+");
  return secondArray[0];
};
